// extracted by mini-css-extract-plugin
export var adjacentSlide = "_t3-9";
export var arrowButtonContainer = "_t3-5";
export var arrowButtonIcon = "_t3-6";
export var carouselArrowButton = "_t3-2";
export var carouselElementContainer = "_t3-1";
export var currentSlide = "_t3-8";
export var left = "_t3-3";
export var otherSlide = "_t3-a";
export var productCarouselContainer = "_t3-0";
export var right = "_t3-4";
export var sliderOverflow = "_t3-7";